import Cookie from 'js-cookie';

const baseUri = 'carts';

export default {
  get() {
    const cart = Cookie.getJSON('cart');

    if (cart === undefined) {
      return api.get('latest-cart').then((response) => {
        Cookie.set('cart', response.data.data);
        return response.data.data;
      });
    }

    return new Promise((resolve, reject) => {
      resolve(cart);
    });
  },

  refresh() {
    const cart = Cookie.getJSON('cart');

    return api.get(`${baseUri}/${cart.id}`).then((response) => {
      Cookie.set('cart', response.data.data);
      return response.data.data;
    });
  },

  show(id) {
    return api.get(`${baseUri}/${id}`);
  },

  create() {
    return api.post(`${baseUri}`);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/cart.js